import React from 'react';
import { CheckIcon } from 'lucide-react';
import { mapIncludes, modules } from '../data/content';
export function WhatYouGet() {
  return <section id="contenido" className="w-full bg-blue-50 py-16 md:py-24" data-id="element-250" data-mp="1026qg5u708yk">
      <div className="mx-auto w-full max-w-5xl px-5 md:px-8" data-id="element-251" data-mp="l4eetorro4pn">
        <header className="mx-auto max-w-4xl text-center" data-id="element-252" data-mp="q2fus0twbnww">
          <h2 className="text-3xl font-extrabold leading-tight tracking-tight text-slate-900 md:text-5xl" data-id="element-253" data-mp="q2oby4x1xfdw">
            Sistema completo: 100 Mappe Visive
            <br data-id="element-254" data-mp="1irmuv4900lk9" />
            <span className="text-blue-600" data-id="element-255" data-mp="1iq21vj2c1aoi">+ 100 Analisi di Esercizi</span>
          </h2>
        </header>

        <ul className="mx-auto mt-12 grid max-w-4xl gap-5 md:grid-cols-3" data-id="element-256" data-mp="141flrf4vsew8">
          {modules.map(module => <li key={module.number} className="flex h-full flex-col rounded-2xl bg-white p-6 shadow-sm ring-1 ring-blue-100" data-id="element-257" data-mp="18zpfdlayj7fq">
              <span className={`h-1.5 w-12 rounded-full ${module.spine}`} aria-hidden="true" data-id="element-258" data-mp="21hux7k4vj7ze" />
              <h3 className="mt-5 text-xl font-extrabold tracking-tight text-slate-900" data-id="element-259" data-mp="2vf0ztmm7xc9w">
                {module.title}
              </h3>
              <p className="mt-1 text-sm font-extrabold uppercase tracking-wider text-blue-600" data-id="element-260" data-mp="2qik9clrjqltn">
                {module.detail}
              </p>
              <p className="mt-4 text-blue-900/75" data-id="element-261" data-mp="30edkq1tj499u">{module.summary}</p>
            </li>)}
        </ul>

        <div className="mx-auto mt-8 max-w-4xl rounded-2xl bg-white p-7 shadow-sm ring-1 ring-blue-100 md:p-9" data-id="element-262" data-mp="3e5in3boa7fnv">
          <h3 className="text-lg font-extrabold tracking-tight text-blue-600 md:text-xl" data-id="element-263" data-mp="39677i5znig7v">
            In ogni mappa trovi:
          </h3>
          <ul className="mt-5 grid gap-4 sm:grid-cols-2" data-id="element-264" data-mp="3o2ewdjm085th">
            {mapIncludes.map(item => <li key={item} className="flex items-start gap-3" data-id="element-265" data-mp="3j3k65wlpjezc">
                <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-emerald-50 text-emerald-600" data-id="element-266" data-mp="1tr9qs9rcxjbi">
                  <CheckIcon className="h-4 w-4" aria-hidden="true" data-id="element-267" data-mp="1otqbd6ixb0hz" />
                </span>
                <span className="text-slate-900" data-id="element-268" data-mp="2ehlvu215tjj7">{item}</span>
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}